import classNames from 'classnames';
import { ReactNode } from 'react';

import CloseButton from '../buttons/CloseButton';

import styles from '../../styles/popups/dialog.module.css';

interface DialogProps {
    children: ReactNode;
    closeable?: boolean;
    fullscreen?: boolean;
    onClose?: () => void | null;
    className?: string | null;
}

function Dialog({
    children,
    closeable = false,
    fullscreen = false,
    onClose,
    className = null,
}: DialogProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.fullscreen]: fullscreen,
                },
                className,
            ])}
        >
            {closeable ? <CloseButton onClick={onClose} className={styles.closeButton} /> : null}
            {children}
        </div>
    );
}

export default Dialog;
